import { render } from "./ExpiredLicense.vue?vue&type=template&id=32fecc16"
import script from "./ExpiredLicense.vue?vue&type=script&lang=js"
export * from "./ExpiredLicense.vue?vue&type=script&lang=js"
script.render = render

export default script